import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Loader2 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
interface SparkContentSectionProps {
  icon?: LucideIcon;
  iconClassName: string;
  title: string;
  subtitle?: string;
  browseAllLink?: {
    href: string;
    label: string;
  };
  footerLink?: {
    href: string;
    label: string;
  };
  bgClassName?: string;
  isLoading?: boolean;
  children: ReactNode;
}
export function SparkContentSection(t0) {
  const $ = _c(21);
  const {
    title,
    subtitle,
    browseAllLink,
    footerLink,
    bgClassName: t1,
    isLoading,
    children
  } = t0;
  const bgClassName = t1 === undefined ? "" : t1;
  const bottomLink = footerLink || browseAllLink;
  if (isLoading) {
    const t2 = `px-5 py-20 sm:px-8 sm:py-28 lg:px-12 ${bgClassName}`;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="mx-auto max-w-[1320px] flex items-center justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-gray-400" /></div>;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] !== t2) {
      t4 = <section className={t2}>{t3}</section>;
      $[1] = t2;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  const t2 = `px-5 py-20 sm:px-8 sm:py-28 lg:px-12 ${bgClassName}`;
  let t3;
  if ($[3] !== subtitle) {
    t3 = <p className="text-sm font-black uppercase tracking-[0.18em] text-[#d63f20]">{subtitle}</p>;
    $[3] = subtitle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <h2 className="mt-4 text-4xl font-black leading-none tracking-[-0.035em] sm:text-6xl">{title}</h2>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="max-w-4xl">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children) {
    t6 = <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">{children}</div>;
    $[10] = children;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== bottomLink) {
    t7 = bottomLink && <div className="mt-12 text-center"><Link href={bottomLink.href} className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-gray-950 bg-white px-7 py-3.5 text-base font-black text-gray-950 transition-transform hover:-translate-y-0.5 hover:shadow-[4px_4px_0_0_#211d4f] cursor-pointer">{bottomLink.label}<ArrowRight className="h-5 w-5" aria-hidden="true" /></Link></div>;
    $[12] = bottomLink;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="mx-auto max-w-[1320px]">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t8) {
    t9 = <section className={t2}>{t8}</section>;
    $[18] = t2;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}